import { type ApiService } from '../types/ApiService';

export type TaxAmountResponse = {
  success: boolean;
  data: {
    taxAmount: number;
    subtotal: number;
    total: number;
  };
};

export const tax = (centralApi: ApiService) => ({
  getAmount: (params: {
    type: string;
    amount: number;
  }): Promise<TaxAmountResponse> => {
    return centralApi.get('/tax/amount', { params });
  },
});
